import React from 'react';
import { css } from 'emotion';

const SpanButton = ({ onClick, children }) => {
  return (
    <span
      className={css`
        cursor: pointer;
        color: #077398;
      `}
      onClick={onClick}>
      {children}
    </span>
  );
};

export default SpanButton;
